import React from 'react';
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';

/**
 * Reusable nav menu item card used in dropdown menus (desktop NavigationMenu).
 */
export default function NavMenuItem({ item, onClick }) {
  const Icon = item.icon;
  return (
    <Link
      to={item.href}
      onClick={onClick}
      className="block select-none rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
    >
      <div className="flex items-center gap-2">
        <Icon className={`w-4 h-4 ${item.guestAccessible ? 'text-emerald-600' : 'text-muted-foreground'}`} />
        <div className="text-sm font-medium leading-none">{item.label}</div>
        {item.guestAccessible && (
          <Globe className="w-3 h-3 text-emerald-600 ml-auto" title="Available to guests" />
        )}
      </div>
      <p className="line-clamp-1 text-xs leading-snug text-muted-foreground mt-1">
        {item.description}
      </p>
    </Link>
  );
}
